<template>
  <FormulateInput
    v-bind="{ ...$props, ...$attrs }"
    :validation-name="label"
    :label="elementLabel"
    type="checkbox"
    class="element"
    :class="{
      'element--radio': as === 'radio',
      'element--checkbox': as !== 'radio',
    }"
  />
</template>

<script>
import requiredLabelMixin from '../requiredLabelMixin';

export default {
  name: 'CheckField',
  mixins: [requiredLabelMixin],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: undefined,
    },
    validation: {
      type: [String, Array],
      default: 'required',
    },
    as: {
      type: String,
      default: 'checkbox',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.element {
  @include utils.bs-media-breakpoint-up(md) {
    >>> .form-check {
      display: inline-block;
    }
  }

  @at-root #{&}--checkbox {
    >>> .form-check-input {
      border-radius: utils.$bs-form-check-input-border-radius;

      &:checked {
        background-image: utils.bs-escape-svg(
          utils.$bs-form-check-input-checked-bg-image
        );
      }
    }
  }

  @at-root #{&}--radio {
    >>> .form-check-input {
      border-radius: utils.$bs-form-check-radio-border-radius;

      &:checked {
        background-image: utils.bs-escape-svg(
          utils.$bs-form-check-radio-checked-bg-image
        );
      }
    }
  }
}
</style>
